(ns web3.components.branch
  (:require ["branch-sdk" :as branch]
            [clojure.spec.alpha :as s]
            [web3.queries.root :as q-root]
            [web3.queries.profile :as q-profile]
            [web3.env :as env]
            [camel-snake-kebab.core :refer [->kebab-case]]
            [re-frame.core :as rf]
            [web3.log :as log :include-macros true]))

(defn init []
  (let [branch-key (env/config :BRANCH_KEY)]
    (if (s/valid? string? branch-key)
      (.init branch branch-key)
      (throw (js/Error. "Your branch key isn't a string")))))

(defn get-link [cb]
  (.link branch #js {} (fn [err link]
                         (cb link))))

(rf/reg-fx :branch.io/set-identity
           (fn [email-address]
             (log/println :debug :branch.io/set-identity email-address)
             (.setIdentity branch email-address)))

(defn track! [event-name]
  (.track branch event-name))

(defn send-sms! [phone-number cb]
  (.sendSMS branch
            phone-number
            #js {:channel "web-app"
                 :feature "upload-mobile-hint"}
            #js {}
            cb))

(rf/reg-fx :branch.io/logout
           #(.logout branch))

(defn parse-branch-error [^js error]
  (or (try (some-> error
                   .-message
                   (js/JSON.parse)
                   .-message)
           (catch js/Error e
             nil))
      (when (some->> (.-message error)
                     (re-find #"\b400\b"))
        "Invalid phone number")
      (do
        (log/debug error (.-message error))
        "Oops! An error occurred, and your SMS could not be sent.")))

(defn- transform-branch-key
  [k]
  (keyword
   (case (first k)
     "$" (str "io.branch.reserved/" (->kebab-case (subs k 1)))
     "~" (str "io.branch.analytic/" (->kebab-case (subs k 1)))
     "+" (str "io.branch.added/" (->kebab-case (subs k 1)))
     k)))

(s/def ::referral-type #{"basic" "pro" "master"})

(s/def ::referrer-id string?)

(s/def ::cookie-data
  (s/keys :req-un [::referrer-id ::referral-type]))

(defn assoc-referrer
  ;; TODO
  ;; use s/fdef
  #_{::s/args (s/cat :branch-data ::cookie-data)}
  [{:keys [referrer-id referral-type] :as branch-data}]
  (log/info "BRANCH REFERAL")
  (log/sym referral-type)
  (log/sym referrer-id)
  (q-profile/create-user-referral!
    {:id referrer-id
     :type referral-type}
    {:component [:div]
     :refetch [q-root/me]}))

(rf/reg-fx :tracking/assoc-referrer assoc-referrer)

(rf/reg-event-fx :tracking/referred
  [(rf/inject-cofx :cookie/get [:referral-type :referrer-id])]
  (fn [{:keys [db] cookie :cookie/get}]
    (let [{:keys [referral-type referrer-id]} cookie]
      (log/info "assoc")
      (log/sym cookie)
      (when (and referral-type referrer-id)
        {:tracking/assoc-referrer cookie}))))
